import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cf94720&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./IngredientRow.scss?vue&type=style&index=0&id=6cf94720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf94720",
  null
  
)

export default component.exports